import axios from "axios";
import Vue from "vue";
import URL from "../config/index";
import { Message } from "element-ui";
import allTits from "../assets/lan/tits.js";
import router from "../router.js";
import store from "../store";
import { BIZ_TOKEN, BIZ_LANGUAGE_MAP, BIZ_TOKEN_EXPIRE, BIZ_TOKEN_EXPIRE_MS } from "@/common/constant";

const axiosInstance = axios.create({
  baseURL: URL.BASE_URL,
  timeout: 15000,
  // headers: {'X-Custom-Header': 'foobar'}
});
// axios.defaults.timeout = 15000;
// axios.defaults.baseURL = URL.BASE_URL;
const requestLangMap = {
  [BIZ_LANGUAGE_MAP.zhCN]: "cn",
  [BIZ_LANGUAGE_MAP.zhTW]: "tw",
  [BIZ_LANGUAGE_MAP.en]: "en",
  [BIZ_LANGUAGE_MAP.ja]: "ja",
  [BIZ_LANGUAGE_MAP.de]: "de",
  [BIZ_LANGUAGE_MAP.ms]: "ms",
  [BIZ_LANGUAGE_MAP.af]: "af",
  [BIZ_LANGUAGE_MAP.th]: "th",
  [BIZ_LANGUAGE_MAP.el]: "el",
  [BIZ_LANGUAGE_MAP.pt]: "pt",
  [BIZ_LANGUAGE_MAP.es]: "es",
  [BIZ_LANGUAGE_MAP.fr]: "fr",
  [BIZ_LANGUAGE_MAP.ru]: "ru",
  [BIZ_LANGUAGE_MAP.it]: "it",
  [BIZ_LANGUAGE_MAP.tr]: "tr",
  [BIZ_LANGUAGE_MAP.ko]: "ko",
  [BIZ_LANGUAGE_MAP.ph]: "ph",
  [BIZ_LANGUAGE_MAP.ar]: "ar",
  [BIZ_LANGUAGE_MAP.id]: "id",
  [BIZ_LANGUAGE_MAP.hi]: "hi",
  [BIZ_LANGUAGE_MAP.vi]: "vi",
};
export const getCurrentLang = () => {
  const lang = store.getters.currentLang;
  return { lang: requestLangMap[lang] };
};

const handlerPostParams = (url, data) => {
  if (Object.keys(data).length) {
    for (let i in data) {
      url += url.indexOf("?") < 0 ? `?${i}=${data[i]}` : `&${i}=${data[i]}`;
    }
  }
  return url;
};

const getTitsMessageMap = () => {
  const currentLang = store.getters.currentLang || BIZ_LANGUAGE_MAP.en;
  const titsKey =
    currentLang === BIZ_LANGUAGE_MAP.zhTW ? "tits_CN" : `tits_${currentLang}`;

  return allTits[titsKey] || allTits.tits_en;
};

const createBackendError = ({
  messageKey = "",
  status,
  fallbackKey = "",
  fallbackMessage = "",
}) => {
  const messageMap = getTitsMessageMap();
  const translatedMessage =
    messageMap[messageKey] ||
    (fallbackKey ? messageMap[fallbackKey] : "") ||
    messageKey ||
    fallbackMessage;
  const backendError = new Error(translatedMessage || fallbackMessage);

  backendError.messageKey = messageKey;
  backendError.status = status;

  return backendError;
};
//http request 拦截器
axiosInstance.interceptors.request.use(
  (config) => {
    const noAuth = config.headers && config.headers.noAuth === true;
    if (noAuth) {
      delete config.headers.noAuth;
      return config;
    }

    // 检查 token 是否过期（15天）
    const tokenExpire = localStorage.getItem(BIZ_TOKEN_EXPIRE);
    if (tokenExpire && Date.now() > Number(tokenExpire)) {
      localStorage.removeItem(BIZ_TOKEN);
      localStorage.removeItem(BIZ_TOKEN_EXPIRE);
    }
    const token = localStorage.getItem(BIZ_TOKEN);
    // config.data = JSON.stringify(config.data);
    // config.headers = {
    //   'Content-Type':'application/x-www-form-urlencoded'
    // }

    // 设置 Authorization header（让后端通过 OAuth2 token 解析 UserId）
    if (token && !config.headers['isToken']) {
      config.headers['Authorization'] = 'Bearer ' + token;
    }
    // 设置 UserId header（后端 SecurityUtils.getUserId() 从此 header 读取）
    const storeHeaders = store.getters.headers;
    if (storeHeaders && storeHeaders['UserId']) {
      config.headers['UserId'] = storeHeaders['UserId'];
      config.headers['username'] = storeHeaders['username'] || '';
    }

    if (config.method == "get") {
      token && (config.params.token = token);
    } else if (config.method == "post") {
      if (config.data.body) {
        config.url = handlerPostParams(config.url, { token, ...config.data.params });
        config.data = config.data.body;
      } else {
        token && (config.data.token = token);
        config.url = handlerPostParams(config.url, config.data);
        config.data = null;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// let msgsCache = {};

// axios.interceptors.response.use(
//   (response) => {


//     return response;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );

//http response 拦截器
axiosInstance.interceptors.response.use(
  (response) => {

    console.log("response ------------------------------------------ res ",response);

    return response;
  },
  (error) => {
    console.log("response ------------------------------------------ error axiosInstance ",error);
    return Promise.reject(error);
  }
);

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function fetch(url, params = {}) {
  params = { ...params, ...getCurrentLang() };
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url, {
        params: params,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function get(url, params = {}, options = {}) {
  params = { ...params, ...getCurrentLang() };
  return new Promise((resolve, reject) => {
    const requestConfig = {
      ...options,
      params: params,
    };
    axiosInstance
      .get(url, requestConfig)
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

/**
 * 封装get同步方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function getSync(url, data = {}) {
  data = { ...data, ...getCurrentLang() };
  return new Promise((resolve, reject) => {
    axiosInstance.get(url, data).then(
      (response) => {
        resolve(response.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url, data = {}) {
  data = { ...data, ...getCurrentLang() };
  return new Promise((resolve, reject) => {
    axiosInstance
    .post(url, {
      data: data,
      }).then((response) => {
        resolve(response.data);
      }).catch((err) => {
        reject(err);
      });


  //     axiosInstance
  //     .get(url, {
  //       params: params,
  //     })
  //     .then((response) => {
  //       resolve(response.data);
  //     })
  //     .catch((err) => {
  //       reject(err);
  //     });
  // });




  });
}

/**
 * 封装post同步请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function postSync(url, data = {}) {
  data = { ...data, ...getCurrentLang() };
  return new Promise((resolve, reject) => {
    axiosInstance.post(url, data).then(
      (response) => {
        resolve(response.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

export function postBody(url, data = {}) {
  data = { params: getCurrentLang(), body: data };
  return new Promise((resolve, reject) => {
    axiosInstance.post(url, data).then(
      (response) => {
        resolve(response.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(url, data = {}) {
  data = { ...data, ...getCurrentLang() };
  return new Promise((resolve, reject) => {
    axiosInstance.patch(url, data).then(
      (response) => {
        resolve(response.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url, data = {}) {
  data = { ...data, ...getCurrentLang() };
  return new Promise((resolve, reject) => {
    axiosInstance.put(url, data).then(
      (response) => {
        resolve(response.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
}
// export default { fetch,get, patch, put,get, post, postBody };



axios.interceptors.request.use(config => {

  console.log("request ------------------------------------------ config ",config);

  // headers中配置serialize为true开启序列化
  if (config.method === 'post' && config.headers.serialize) {
    config.data = serialize(config.data)
    // config.headers=['Content-Type'] = 'application/x-www-form-urlencoded';
    delete config.data.serialize
  }
  if (store.getters.isLogin&&config.method === 'post'||config.method === 'put'){
    config.headers=store.getters.headersJson;
  }else if(store.getters.isLogin&&config.method === 'get'||config.method === 'delete'){
    config.headers=store.getters.headers;
  }

  if (config.method === 'get' && config.params) {
    let url = config.url + '?';
    for (const propName of Object.keys(config.params)) {
      const value = config.params[propName];
      var part = encodeURIComponent(propName) + "=";
      if (value !== null && typeof (value) !== "undefined") {
        if (typeof value === 'object') {
          for (const key of Object.keys(value)) {
            let params = propName + '[' + key + ']';
            var subPart = encodeURIComponent(params) + "=";
            url += subPart + encodeURIComponent(value[key]) + "&";
          }
        } else {
          url += part + encodeURIComponent(value) + "&";
        }
      }
    }
    url = url.slice(0, -1);
    config.params = {};
    config.url = url;
  }



  return config
}, error => {
  return Promise.reject(error)
})

// HTTPresponse拦截
axios.interceptors.response.use(res => {
  console.log("response ------------------------------------------ res ",res);

  // NProgress.done()
  const status = Number(res.status) || 200
  const message = res.data.message;
  // const i18nMessageJsons= JSON.parse(sessionStorage.getItem("messages"));

  console.log("response ------------------------------------------ res ",res);


  //非正常返回
  if (status !== 200 || res.data.code === 1) {

    console.log("response status",status);
    console.log("response message",message);
    console.log("response ------------------------------------------ res ",res);
    console.log("response code",res.data.code);

    // if (status === 400) {
    //   ElMessageBox({
    //     message: i18nMessageJsons[message] || i18nMessageJsons['common_message_badRequest'],
    //     type: 'error'
    //   })
    //   return Promise.reject(new Error(i18nMessageJsons['common_message_badRequest']));
    // }
    // //登录异常
    if (status === 401) {
      console.log("response ------------------------------------------ error 401 messages",JSON.parse(error.request.response));
      ElMessageBox({
        message: i18nMessageJsons[message] || i18nMessageJsons['common_message_unauthorized'],
        type: 'error'
      }).then(() => {
        store.dispatch('LogOut').then(() => {
          // 刷新登录页面，避免多次弹框
          window.location.reload();
        })
        // window.location.reload();
      })
      return Promise.reject(new Error(i18nMessageJsons['common_message_unauthorized']));
    }
    // //请求被拒绝
    // if (status === 403) {
    //   ElMessageBox({
    //     message: i18nMessageJsons[message] || i18nMessageJsons['common_message_forbidden'],
    //     type: 'error'
    //   })
    //   return Promise.reject(new Error(i18nMessageJsons['common_message_forbidden']));
    // }
    // //请求后台资源不存在
    // if (status === 404) {
    //   ElMessageBox({
    //     message: i18nMessageJsons[message] || i18nMessageJsons['common_message_notFound'],
    //     type: 'error'
    //   })
    //   return Promise.reject(new Error(i18nMessageJsons['common_message_notFound']));
    // }
    // //请求数据异常
    // if (status === 422) {
    //   ElMessageBox({
    //     message: i18nMessageJsons[message] || i18nMessageJsons['common_message_unprocessableEntity'],
    //     type: 'error'
    //   })
    //   return Promise.reject(new Error(i18nMessageJsons['common_message_unprocessableEntity']));
    // }
    // //登录令牌过期
    // if (status === 424) {
    //   ElMessageBox.confirm(i18nMessageJsons[message] || i18nMessageJsons['common_message_timeoutAuthorized'], i18nMessageJsons['common_syshint'], {
    //     confirmButtonText: i18nMessageJsons['common_ok'],
    //     cancelButtonText: i18nMessageJsons['common_cancel'],
    //     type: 'warning'
    //   }).then(() => {
    //     store.dispatch('LogOut').then(() => {
    //       // 刷新登录页面，避免多次弹框
    //       window.location.reload()
    //     })
    //     // window.location.reload();
    //   }).catch(() => {})
    //   return
    // }
    // //后台服务异常、未启动、链接错误
    // if (status === 503) {
    //   ElMessageBox({
    //     message: i18nMessageJsons[message] ||i18nMessageJsons['common_message_serviceUnavailable'],
    //     type: 'error'
    //   })
    //   return Promise.reject(new Error(i18nMessageJsons['common_message_serviceUnavailable']));
    // }
    // //后台内部错误
    // if (status === 500) {
    //   ElMessageBox({
    //     message: i18nMessageJsons[message] ||i18nMessageJsons['common_message_internalServerError'],
    //     type: 'error'
    //   })
    //   return Promise.reject(new Error(i18nMessageJsons['common_message_internalServerError']));
    // }
    // ElMessageBox({
    //   message: i18nMessageJsons[message],
    //   type: 'error'
    // })
    return Promise.reject(new Error(message))
  }
  return res
}, error => {

  console.log("response ------------------------------------------ error axios error",error.response);
  // console.log("response ------------------------------------------ error axios error.request",JSON.parse(error.request.response));
  // console.log("response ------------------------------------------ error axios messages",JSON.parse(error.request.response));

  if (!error.response) {
    return Promise.reject(error);
  }

  const status = Number(error.response.status)
  let message = '';
  try {
    // 优先从 error.response.data 获取，这是 axios 的标准错误响应格式
    const responseData = error.response.data || {};
    message = responseData.message || '';
    // 如果 data 中没有 message，尝试从 request.response 解析
    if (!message && error.request && error.request.response) {
      const responseJson = JSON.parse(error.request.response);
      message = responseJson.message || '';
    }
  } catch (e) {
    message = error.message || 'Unknown error';
  }

  if (status === 400) {
    console.log("HTTP 400 error, message:", message);
    return Promise.reject(
      createBackendError({
        messageKey: message,
        status,
        fallbackMessage: "请求参数错误",
      })
    )
  }
  // //登录异常
  if (status === 401) {

    //清tocken
        // store.dispatch('LogOut').then(() => {
         // 刷新登录页面，避免多次弹框
        // window.location.reload();
  }
  //请求被拒绝
  if (status === 403) {

  }
  //请求后台资源不存在
  if (status === 404) {

  }
  //请求数据异常
  if (status === 422) {
    return Promise.reject(
      createBackendError({
        messageKey: message,
        status,
        fallbackKey: 'common_message_unprocessableEntity',
        fallbackMessage: '请求数据异常，无法处理',
      })
    )
  }
  //登录令牌过期
  if (status === 424) {

    //清tocken
    // store.dispatch('LogOut').then(() => {
      // 刷新登录页面，避免多次弹框
    // window.location.reload();
    
  }
  //后台服务异常、未启动、链接错误
  if (status === 503) {


  }
  //后台内部错误
  if (status === 500) {

    
  }
  //   message: "System failure. Please contact service provider",
  //   type: 'error'

  return Promise.reject(error)
})

// 通用下载方法
export function download(url, params, filename) {
  return axios.post(url, params, {
    transformRequest: [(params) => {
      return tansParams(params)
    }],
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    responseType: 'blob'
  }).then((data) => {
    const content = data
    const blob = new Blob([content])
    if ('download' in document.createElement('a')) {
      const elink = document.createElement('a')
      elink.download = filename
      elink.style.display = 'none'
      elink.href = URL.createObjectURL(blob)
      document.body.appendChild(elink)
      elink.click()
      URL.revokeObjectURL(elink.href)
      document.body.removeChild(elink)
    } else {
      navigator.msSaveBlob(blob, filename)
    }
  }).catch((r) => {
    console.error(r)
  })
}
export default axios
